module.exports = "/_next/static/images/aq-4b2c7d76cd664fd1708d9dda84dcc1f7.svg";